// src/components/PrintModal.js
import React, { useState, useEffect } from "react";

const PrintModal = ({ order, onClose, onPrint }) => {
  const [printSize, setPrintSize] = useState("aldi"); // Default to Aldi size
  const [printer, setPrinter] = useState("default");
  const [availablePrinters, setAvailablePrinters] = useState([]);

  useEffect(() => {
    // Simulate printer detection (replace with actual Bluetooth detection if needed)
    setAvailablePrinters(["Default Printer", "Bluetooth Printer"]);
  }, []);

  return (
    <div className="print-modal-overlay">
      <div className="print-modal">
        <h3>Print Invoice #{order.id}</h3>
        <div className="print-option">
          <label>Paper Size:</label>
          <select value={printSize} onChange={(e) => setPrintSize(e.target.value)}>
            <option value="aldi">Aldi Thermal (80mm)</option>
            <option value="a4">A4</option>
          </select>
        </div>
        <div className="print-option">
          <label>Printer:</label>
          <select value={printer} onChange={(e) => setPrinter(e.target.value)}>
            {availablePrinters.map((printer) => (
              <option key={printer} value={printer}>
                {printer}
              </option>
            ))}
          </select>
        </div>
        <div className="print-actions">
          <button onClick={onClose}>Cancel</button>
          <button onClick={() => onPrint({ printSize, printer })}>Print</button>
        </div>
      </div>
    </div>
  );
};

export default PrintModal;
